// extracted by mini-css-extract-plugin
module.exports = {"statsBanner":"StatsBanner_statsBanner__MmYt6","statsItem":"StatsBanner_statsItem__36rk_","imgTxt":"StatsBanner_imgTxt__3FApS"};